import { getFlatTaskList } from './DbTaskToFlatTask';

export default {
  DbTaskToFlatTask: getFlatTaskList,
};
